import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import CreateClient from './form'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Portal from '@mui/material/Portal'
import Grid from '@mui/material/Grid'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Checkbox from '@mui/material/Checkbox'
import Switch from '@mui/material/Switch'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Stack from '@mui/material/Stack'
import { useTheme } from '@emotion/react'
//import ArraCard from './Arra'

import ArraRequisition from './Arra'
const ArraCard = ({client, action, check, isSelected, ...rest}) => {
	return(
		<ClientCard client={client} aciton={action} check={check} isSelected={isSelected}>
			<ArraRequisition cid={client.id} />
		</ClientCard>
	)
}

const ClientCard = ({client, action, check, isSelected, ...rest}) => {

	const theme = useTheme()
	
	const [m_checked, setChecked_m] = React.useState(client.metrics?true:false)
	const onCheck_m = (e)=>{
		const c = !m_checked
		setChecked_m(c);
		check('m', c?1:0)
	}
	const [w_checked, setChecked_w] = React.useState(client.externalwarehousing_detail?true:false)
	const onCheck_w = (e)=>{
		const c = !w_checked
		setChecked_w(c);
		check('w', c?1:0)
	}
	const [o_checked, setChecked_o] = React.useState(client.onlyEvents?true:false)
	const onCheck_o = (e)=>{
		const c = !o_checked
		setChecked_o(c);
		check('o', c?1:0)
	}
	const [p_checked, setChecked_p] = React.useState(client.pick_and_pack>0?true:false)
	const [pickNPack, setPP] = React.useState(client.pick_and_pack)
	const onCheck_p = (e)=>{
		const c = !p_checked
		setChecked_p(c);	
		if(!c) check('p', 0)
	}

	const changePickPack = (e) => !isNaN(e.target.value) && setPP(e.target.value)
	const setPickPack = () => check('p', pickNPack)


	const [f_checked, setChecked_f] = React.useState(client.factoring>0?true:false)
	const [factoring, setFF] = React.useState(client.factoring)
	const onCheck_f = (e)=>{
		const c = !f_checked
		setChecked_f(c);	
		if(!c) check('f', 0)
	}

	const changeFactoring = (e) => !isNaN(e.target.value) && setFF(e.target.value)
	const setFactoring = () => check('f', factoring)

	return (
		<Card sx={{'margin': '15px 10px', backgroundColor:isSelected?theme.palette.primary.light:"transparent", color:isSelected?theme.palette.contrast.main:"black"}} >
			<CardContent sx={{cursor:'pointer'}} onClick={event => action && action(client)}>
			<Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
				{client.bundle}
			</Typography>
			<Typography variant="h5" component="div">
				{client.name}
			</Typography>
			<Typography sx={{ mb: 1.5 }} color="text.secondary">
				{client.products.length} productos
			</Typography>
			</CardContent>
			<CardActions>
				<Stack sx={{minWidth:'200px', maxWidth:'400px'}}>
					<FormControl sx={{ m: 1, width: '25ch' }}>
						<FormControlLabel control={
							<Checkbox
								onClick={onCheck_m}
								name={"metrics"+client.id}
								defaultChecked={client.metrics?true:false}
							/>
						} label="Incluir métricas" />
						<FormControlLabel control={
							<Checkbox
								onClick={onCheck_o}
								name={"onlyEvents"+client.id}
								defaultChecked={client.onlyEvents?true:false}
							/>
						} label="Solo eventos de venta" />
						<FormControlLabel control={
							<Checkbox
								onClick={onCheck_w}
								name={"externalwarehousing_detail"+client.id}
								defaultChecked={client.externalwarehousing_detail?true:false}
							/>
						} label="Incluir costos de almacén por producto" />
						<FormControlLabel control={
							<Switch
								onClick={onCheck_p}
								name={"pick_and_pack"+client.id}
								defaultChecked={client.pick_and_pack>0?true:false}
							/>
						} label={p_checked?"":"Incluir Pick & Pack"} />
						{p_checked && 
							<React.Fragment>
								<TextField label="Incluir Pick & Pack" variant="outlined" defaultValue={client.pick_and_pack} value={pickNPack} onChange={changePickPack}/>
								{pickNPack != client.pick_and_pack && <Button onClick={setPickPack}>Guardar</Button>}
							</React.Fragment>
						}
							<FormControlLabel control={
							<Switch
								onClick={onCheck_f}
								name={"factoring"+client.id}
								defaultChecked={!isNaN(client.factoring) && client.factoring!=0?true:false}
							/>
						} label={f_checked?"":"Incluir Factoraje"} />
						{f_checked && 
							<React.Fragment>
								<TextField label="Incluir Factoraje" variant="outlined" defaultValue={client.factoring} value={factoring} onChange={changeFactoring}/>
								{factoring != client.factoring && <Button onClick={setFactoring}>Guardar</Button>}
							</React.Fragment>
						}

						</FormControl>
				{rest.children}	    		
				</Stack>
			</CardActions>
		</Card>
	)
}

const ClientsToolbar = ({selected, create, edit, ...rest}) => {
	return (
			<Toolbar sx={{
			    pl: { sm: 2 },
			    pr: { xs: 1, sm: 1 },
				position: 'fixed',
    			background: 'white',
    			border: '1px solid',
    			zIndex: '10',
    			borderRadius: '9px',
				right: '15px'
			  }}
			  color="primary"
			>
				<Button onClick={create}>
					<Typography marginRight="10px">Crear Cliente</Typography>
					<AddIcon />
				</Button>
		  	{selected && 
				<Button onClick={edit}>
				<Typography marginRight="10px">{"Editar cliente " + selected.name}</Typography>
				<EditIcon />
				</Button>
			}
			</Toolbar>
	)
}

const ClientsBoard = () => {
	const app = React.useContext(AppContext)
	const { current } = app
	const { clients, metrics, externalwarehousing_detail, pick_and_pack, factoring, detail } = app.clients
	const customContainer = React.useRef(null)
	const [open, setOpen] = React.useState(false)
	const openD = () => setOpen(true)
	
	const check = (s,m, clientId) => {

		switch(s){
			case'm':
				metrics(clientId,m)
				break;
			case'w':
				externalwarehousing_detail(clientId, m)
				break;
			case'p':
				pick_and_pack(clientId,m)
				break;
			case'f':
				factoring(clientId,m)
				break;
			default:break;
		}

	}

	return (
		<Box sx ={{
			width: "100%",
			display: "flex",
			alignItems: "baseline",
			justifyContent: "space-evenly",
			flexWrap: "wrap",
			flexDirection: "row",
			alignContent: "center",
			padding:'30px',
		}}>
			<ClientsToolbar selected={current} create={openD} edit={openD}/>
			<Grid container sx={{mt:10}} >
				{clients && 
					clients.map(client => (
						<Grid item><ClientCard isSelected={current && current.name == client.name} key={client.name} client={client} action={detail} check={(s,m) => check(s,m, client.id) }/></Grid>
					))
				}
			</Grid>
			<Grid container spacing={2} ref={customContainer}/>
			<CreateClient model={current} open={open} close={() => setOpen(false)}/>
		</Box>
	)

}



export default  () => {

	return (
			<Box>
				<ClientsBoard/>
			</Box>
	)
}